import type { ITextBoxProps } from 'atoms/TextBox'

import { TextBoxColors } from 'atoms/TextBox'
import { TextBoxMaxLine1FontSm } from 'atoms/TextBox/Templates'
import { TextBlockAccountInfoSC } from './TextBlockAccountInfo.styled'

export interface ITextBlockAccountInfo {
  title?: ITextBoxProps['title']
  description?: ITextBoxProps['title']
  colorTitle?: TextBoxColors
  colorDescription?: TextBoxColors
  dataTestTitleId?: string
}

export const TextBlockAccountInfo = ({
  title = '',
  description = '',
  colorTitle = TextBoxColors.TEXT_ICON_SECONDARY,
  colorDescription = TextBoxColors.TEXT_ICON_PRIMARY,
  dataTestTitleId = '',
}: ITextBlockAccountInfo) => {
  return (
    <TextBlockAccountInfoSC>
      <TextBoxMaxLine1FontSm
        title={title}
        color={colorTitle}
        dataTestId={dataTestTitleId}
      />

      <TextBoxMaxLine1FontSm title={description} color={colorDescription} />
    </TextBlockAccountInfoSC>
  )
}
